import { useState, useEffect } from "react";
import { Button } from "reactstrap";

import styles from './LanguageSelector.css';
import HUFlag from "./flags/flag_hu.jpg";
import UKFlag from "./flags/flag_uk.jpg";


function LanguageSelector( { lang, onLangChange }) {

    const languages = [
        {value: 0, label: <><img src={HUFlag} alt="HU" style={{width: "20px", marginRight: "8px"}} /> HU</>},
        {value: 1, label: <><img src={UKFlag} alt="EN" style={{width: "20px", marginRight: "8px"}} /> EN</>}
    ];
    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const [selectedLang, setSelectedLang] = useState(lang);

    useEffect(() => {
        setSelectedLang(lang);
    }, [lang]);

    const changeLang = (value) => {
        fetch(`${API_URL}/common/set_lang.php`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({lang: value})
        });
        setSelectedLang(value);
        onLangChange(value);
    };

    return (
            <>
            {languages.map((o) => (
                                    selectedLang !== o.value && (
                                                <Button key={o.value} onClick={() => changeLang(o.value)} color="primary" className="no-wrap m-1 lang-selector" outline>
                                                    {o.label}
                                                </Button>
                                            )
                                    ))}
            </>
            );
}

export default LanguageSelector;
